import router from '@/router'
import companiesService from '@/services/companiesService'

const state = {
  companies: [],
  loadingCompanies: true,
  loadingUsersCompany: false,
  paginationUsersCompany: {},
  searchUsersCompany: '',
  selectedCompany: {},
  totalUsersCompany: 0,
  administrators: [],
  allPermissions: [],
  administrator: {},
  administratorRoles: [],
  rolesGroups: []
}

const mutations = {
  CLEAR_SELECTED_COMPANY (state) {
    state.selectedCompany = {}
  },
  SET_COMPANIES (state, companies) {
    state.companies = companies
  },
  SET_LOADING_COMPANIES (state, status) {
    state.loadingCompanies = status
  },
  SET_LOADING_USERS_COMPANY (state, status) {
    state.loadingUsersCompany = status
  },
  SET_PAGINATION_USERS_COMPANY (state, pagination) {
    state.paginationUsersCompany = pagination
  },
  SET_SELECTED_COMPANY (state, company) {
    state.selectedCompany = company
  },
  SET_TOTAL_USERS_COMPANY (state, totalUsersCompany) {
    state.totalUsersCompany = totalUsersCompany
  },
  SET_USERS_COMPANY (state, usersCompany) {
    state.administrators = usersCompany
  },
  SET_ADMINISTRATOR (state, administrator) {
    state.administrator = administrator
  },
  SET_ALL_PERMISSIONS (state, allPermissions) {
    state.allPermissions = allPermissions
  },
  SET_ROLES_GROUPS (state, rolesGroups) {
    state.rolesGroups = rolesGroups
  }
}

const actions = {
  async createCompany (vuexContext, data) {
    await companiesService.createCompany(vuexContext.getters.token, data)
    vuexContext.dispatch('getCompanies')
    return true
  },
  getCompany (vuexContext, uuid) {
    return new Promise((resolve, reject) => {
      this._vm.$socket.emit('leaveRoom', {
        name: vuexContext.getters.companyUuid
      })
      vuexContext.commit('SET_LOADING_COMPANIES', true)
      companiesService
        .getCompany(vuexContext.getters.token, uuid)
        .then(response => {
          if (response.company) {
            vuexContext.commit('SET_SELECTED_COMPANY', response.company)
            // vuexContext.dispatch('checkPaymentState')
            resolve(true)
            // Get charge types for this new selected company
            vuexContext.dispatch('getChargeTypes')
            // every time getCompany is called. It makes socket.emit('companyRoom') to connect to a new room
            this._vm.$socket.emit('companyRoom', {
              jwt: vuexContext.getters.token,
              name: vuexContext.getters.companyUuid
            })
          } else {
            vuexContext.commit('SET_SELECTED_COMPANY', {})
            reject(new Error('No se encontró el negocio'))
          }
          vuexContext.commit('SET_LOADING_COMPANIES', false)
        })
    })
  },
  async getCompanies (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_COMPANIES', true)
      let companies = await companiesService.getCompanies(vuexContext.getters.token)
      companies = companies.companies.rows

      vuexContext.commit('SET_COMPANIES', companies)

      if (Object.keys(vuexContext.state.selectedCompany).length === 0 && companies.length > 0) {
        const selectedCompany = companies[0]
        await vuexContext.dispatch('getCompany', companies[0].UUID)
        // Get charge types for this new selected company
        vuexContext.dispatch('getChargeTypes')
        if (selectedCompany.apps.length > 0) {
          vuexContext.dispatch('getApp', {
            appId: selectedCompany.apps[0].UUID,
            getStatistics: false
          })
        } else {
          await router.push('apps/new')
        }
      }
      vuexContext.commit('SET_LOADING_COMPANIES', false)
    } catch (e) {
      vuexContext.commit('SET_COMPANIES', [])
      vuexContext.commit('SET_APPS', [])
      vuexContext.commit('CLEAR_SELECTED_COMPANY')
      vuexContext.commit('CLEAR_SELECTED_APP')
      vuexContext.commit('SET_LOADING_COMPANIES', false)
    }
  },
  async getAdministrators (vuexContext, searchValue) {
    const company = vuexContext.getters.companyUuid
    try {
      const response = await companiesService.getAdministrators(
        vuexContext.getters.token,
        company,
        searchValue,
        vuexContext.state.paginationUsersCompany)
      vuexContext.commit('SET_TOTAL_USERS_COMPANY', response.count)
      vuexContext.commit('SET_USERS_COMPANY', response.users)
      vuexContext.commit('SET_LOADING_USERS_COMPANY', false)
    } catch (e) {
      vuexContext.commit('SET_USERS_COMPANY', [])
      vuexContext.commit('SET_LOADING_USERS_COMPANY', false)
      throw e
    }
  },
  async getAdministrator (vuexContext, { companyId, administratorId }) {
    const company = companyId || vuexContext.getters.companyUuid
    try {
      const response = await companiesService.getAdministrator(
        vuexContext.getters.token,
        company,
        administratorId)
      if (response.users[0]) {
        vuexContext.commit('SET_ADMINISTRATOR', response.users[0])
      }
      return true
    } catch (e) {
      vuexContext.commit('SET_ADMINISTRATOR', {})
      throw e
    }
  },
  async newAdministrator (vuexContext, data) {
    await companiesService.newAdministrator(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      data)
    vuexContext.dispatch('getAdministrators')
    return true
  },
  async updateAdministrator (vuexContext, data) {
    const token = vuexContext.getters.token
    const company = vuexContext.getters.companyUuid
    return await companiesService.updateAdministrator(token, company, data)
  },
  inviteAdministrator (vuexContext, { companyId, users }) {
    return new Promise((resolve, reject) => {
      const company =
                companyId || vuexContext.rootState.companies.selectedCompany.id
      companiesService
        .inviteAdministrator(vuexContext.getters.token, company, users)
        .then(response => {
          resolve(true)
        })
    })
  },
  async removeAdministrator (vuexContext, { companyId, userId }) {
    const company = companyId || vuexContext.getters.companyUuid
    await companiesService.removeAdministrator(
      vuexContext.getters.token,
      company,
      userId)
    await vuexContext.dispatch('getAdministrators')
    return true
  },
  updateCompany (vuexContext, { name, phone, email, address, url }) {
    return new Promise((resolve) => {
      companiesService
        .updateCompany(
          vuexContext.getters.token,
          vuexContext.getters.companyUuid,
          { name, phone, email, address, url }
        )
        .then(() => {
          vuexContext.dispatch('getCompanies')
          vuexContext.dispatch('getCompany', vuexContext.getters.companyUuid)
          resolve(true)
        })
    })
  },
  async getAllPermissions (vuexContext) {
    const response = await companiesService.getAllPermissions(vuexContext.getters.token)
    vuexContext.commit('SET_ALL_PERMISSIONS', response.data.adminRoles)
  },
  async getRolesGroups (vuexContext) {
    const response = await companiesService.getAllPermissions(vuexContext.getters.token)
    vuexContext.commit('SET_ROLES_GROUPS', response.data.groups)
  },
  // sockets:
  socket_companyUpdate (vuexContext, company) {
    vuexContext.commit('SET_SELECTED_COMPANY', company)
  }
}

const getters = {
  administratorRoles (state) {
    return state.selectedCompany.roles || []
  },
  companyUuid (state) {
    return state.selectedCompany.UUID
  },
  companyBalance (state) {
    return parseFloat(state.selectedCompany.balance)
  },
  companyPaymentState (state) {
    return state.selectedCompany.paymentState
  },
  companyIsMonthlyBilling (state) {
    return state.selectedCompany.monthlyBilling
  },
  companyBlocked (state) {
    return state.selectedCompany.paymentState === 'block' && !state.selectedCompany.monthlyBilling
  },
  administrators (state) {
    return state.administrators.map(item => {
      if (item.name === null) item.name = ''
      if (item.fullName === null) item.fullName = ''
      if (item.email === null) item.email = ''
      if (item.phone === null) item.phone = ''
      return { ...item }
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
